export class TaxReductDetails {
	totOver: number;
	profitTot: number;
	profitYear: number;
	profitMonth: number;
}
